const KEY = 'nexsap_seen';

export function markSeen(col, id) {
  const s = loadSeen();
  s.add(`${col}:${id}`);
  try { localStorage.setItem(KEY, JSON.stringify([...s])); } catch {}
}

export function loadSeen() {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); }
  catch { return new Set(); }
}
